import React, { useState } from "react";
import CustomButton from "../shared/CustomButton";
import InputKeyValue from "../shared/InputKeyValue";
import {
  CAMPAIGN_OPTION_WALLET_TYPE,
  ChevronRight,
  formatNumber,
  getCartTotalValue,
  getCartWalletType,
  getCartWalletIsFixedType,
  Mail,
  Phone,
  ShoppingCart02,
  t,
  withContainers,
} from "../normalizer";

import {
  CampaignUserContainer,
  ShoppingCartContainer,
} from "../../containers/gamification2026";

// Digital-only checkout step. The primary e-mail/phone come read-only from
// the shipment address selected in the previous "Dados de envio" step; the
// user must re-type them in the confirmation fields to proceed.
const ContactForm = (props) => {
  const { cart, campaignUser, onSaveContacts } = props;

  const showMonetaryValue =
    getCartWalletType(cart) === CAMPAIGN_OPTION_WALLET_TYPE &&
    getCartWalletIsFixedType(cart) === false;

  const shipmentAddress = cart.shipment_address || {};
  const email = shipmentAddress.email || "";
  const phone = shipmentAddress.phone || "";

  const contacts = cart.contacts || {};
  const [emailConfirm, setEmailConfirm] = useState(contacts.email || "");
  const [phoneConfirm, setPhoneConfirm] = useState(contacts.phone || "");

  const emailMismatch = emailConfirm.length > 0 && email !== emailConfirm;
  const phoneMismatch = phoneConfirm.length > 0 && phone !== phoneConfirm;

  const isValid =
    email.length > 0 &&
    email === emailConfirm &&
    phone.length > 0 &&
    phone === phoneConfirm;

  const handleSubmit = () => {
    if (!isValid) return;
    onSaveContacts({ email: email, phone: phone });
  };

  return (
    <div className="cart-contacts">
      <div className="cart-container">
        <div className="cart-container-content">
          <div className="cart-container-contacts">
            <div className="cart-container-contacts-legend">
              {t("gamification2026.cart.contacts-email-title")}
            </div>
            <div className="cart-container-contacts-row">
              <InputKeyValue
                type="email"
                name="email"
                title={t("gamification2026.cart.contacts-email")}
                placeholder={t("gamification2026.cart.contacts-email")}
                leftIcon={<Mail />}
                value={email}
                readOnly
              />
              <InputKeyValue
                type="email"
                name="email-confirm"
                title={t("gamification2026.cart.contacts-email-confirm")}
                placeholder={t("gamification2026.cart.contacts-email-confirm")}
                leftIcon={<Mail />}
                value={emailConfirm}
                onChange={(e) => setEmailConfirm(e.target.value)}
                error={emailMismatch ? [t("gamification2026.cart.contacts-email-mismatch")] : null}
              />
            </div>
          </div>
          <div className="cart-container-contacts">
            <div className="cart-container-contacts-legend">
              {t("gamification2026.cart.contacts-phone-title")}
            </div>
            <div className="cart-container-contacts-row">
              <InputKeyValue
                type="tel"
                name="phone"
                title={t("gamification2026.cart.contacts-phone")}
                placeholder={t("gamification2026.cart.contacts-phone")}
                leftIcon={<Phone />}
                value={phone}
                readOnly
              />
              <InputKeyValue
                type="tel"
                name="phone-confirm"
                title={t("gamification2026.cart.contacts-phone-confirm")}
                placeholder={t("gamification2026.cart.contacts-phone-confirm")}
                leftIcon={<Phone />}
                value={phoneConfirm}
                onChange={(e) => setPhoneConfirm(e.target.value)}
                error={phoneMismatch ? [t("gamification2026.cart.contacts-phone-mismatch")] : null}
              />
            </div>
          </div>
        </div>
        <div className="cart-container-checkout">
          <ShoppingCart02 className="cart-container-checkout-icon" />
          <div className="cart-container-checkout-group">
            <div className="cart-container-checkout-title1">Total</div>
            <div className="cart-container-checkout-total">
              {showMonetaryValue
                ? `${formatNumber(cart.total_points)} pontos = ${formatNumber(getCartTotalValue(cart))}€`
                : `${formatNumber(cart.total_points)} pontos`}
            </div>
          </div>
          <div className="cart-container-checkout-group">
            <div className="cart-container-checkout-title2">
              Pontos disponíveis
            </div>
            <div className="cart-container-checkout-available-points">
              {formatNumber(campaignUser.availablePoints)} pontos
            </div>
          </div>
          <CustomButton
            className="cart-container-checkout-button"
            onClick={handleSubmit}
            disabled={!isValid}
          >
            {t("gamification2026.cart.next")}
            <ChevronRight />
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default withContainers(ContactForm, [
  CampaignUserContainer,
  ShoppingCartContainer,
]);
